import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';

export const dashboardRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/dashboard',
  component: lazyRouteComponent(() => import('@/pages/dashboard/dashboard-page')),
});
